import { Divider, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ArrowSwapHorizontal } from "iconsax-react";
import { millisecondsToHoursAndMinutes } from "../../../../utils/time";
import Lottie from "react-lottie";
import animationData from "../../../../assets/lotties/Arrow_Plan.json";

//import general components
import { BaseButton } from "../../../../components/common/base-button/base-button";

//import styles
import "./free-item.scss";

function FreeItem({ info, handleReplaceModal, index, length }) {
    const { t } = useTranslation();

    //lotties
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice",
        },
    };

    return (
        <Grid container item xs={10.5} md={12}>
            <Grid
                className="free-item"
                container
                item
                xs={12}
                md={10}
                rowGap={{ xs: 0, md: 2 }}
                justifyContent={{ xs: "space-between", md: "center" }}
                alignItems={{ xs: "center", md: "flex-start" }}
            >
                <Grid container item xs={12} display={{ xs: "none", md: "flex" }} justifyContent="center">
                    <img className="free-item__image" src={"https://api.atripa.com" + info.image} />
                </Grid>
                <Grid container item xs={5} md={12} rowGap={{ xs: 0, md: 2 }}>
                    <Grid className="free-item__title" container item xs={12} justifyContent={{ xs: "flex-start", md: "center" }} columnGap={1}>
                        {millisecondsToHoursAndMinutes(
                            new Date("06/29/2023 " + info.end_time.substr(0, 2) + ":" + info.end_time.substr(2, 2)).getTime() -
                                new Date("06/28/2023 " + info.start_time.substr(0, 2) + ":" + info.start_time.substr(2, 2)).getTime(),
                        )}
                        <span>{t("freeTime")}</span>
                    </Grid>

                    <Grid container item xs={12} justifyContent={{ xs: "flex-start", md: "space-between" }} alignItems="center">
                        <Grid className="free-item__time" container item xs="auto" md={2.5} justifyContent="center">
                            {info.start_time.substr(0, 2) + ":" + info.start_time.substr(2, 2)}
                        </Grid>
                        <Grid container item xs={1} md={1} justifyContent="center">
                            <Divider sx={{ width: { xs: "50%", md: "100%" }, borderBottomColor: "var(--teal-color-18)" }} />
                        </Grid>
                        <Grid className="free-item__time" container item xs="auto" md={2.5} justifyContent="center">
                            {info.end_time.substr(0, 2) + ":" + info.end_time.substr(2, 2)}
                        </Grid>
                    </Grid>
                </Grid>

                <Grid container item xs={4} md={10}>
                    <BaseButton
                        text={t("replace")}
                        color="primary"
                        size="small"
                        radius="radius-20"
                        rightIcon={<ArrowSwapHorizontal color="var(--light-color)" />}
                        handleClick={() => handleReplaceModal(info)}
                    />
                </Grid>
            </Grid>
            <Grid
                className="itinerary-item__lottie"
                container
                item
                xs={2}
                display={{ xs: "none", md: index === length - 1 ? "none" : "flex" }}
                alignItems="center"
            >
                <div>
                    <Lottie options={defaultOptions} />
                </div>
            </Grid>
        </Grid>
    );
}

export default FreeItem;
